import type { ICustomControlSupervisionReadProps } from '../../interfaces/';
import { getDisplayName } from '../../../../../../common/utils/getDisplayName';
import { translateKey } from '../../../../../translate';
import { ProcessItemFooter } from '../../../episodes/ProcessItemFooter';
import { ProcessItemHeader } from '../../../episodes/ProcessItemHeader';
import { CustomControlCollapseBody } from '../../utils/v1/CustomControlCollapseBody';
import { TooV1SupervisionReadFields } from './TooV1SupervisionReadFields';

export function TooV1SupervisionRead(props: ICustomControlSupervisionReadProps): JSX.Element {
    const { supervision, itemState, isFirstItem, process, updateItemState } = props;

    return (
        <>
            <ProcessItemHeader
                date={supervision.sentDateTime}
                icon="checkup"
                isFirstItem={isFirstItem}
                isItemOpen={itemState.isOpen}
                onToggle={async (isOpened) =>
                    await updateItemState({ ...itemState, isOpen: isOpened || itemState.initialIsOpen === true })
                }
                organizationName={supervision.performerOrganization?.name}
                practitionerName={
                    supervision.performerPractitioner ? getDisplayName(supervision.performerPractitioner) : undefined
                }
                process={process}
                showProcessIcon={true}
                title={translateKey('tooSupervision.feedbackTitle')}
            />
            <CustomControlCollapseBody isOpen={itemState.isOpen}>
                <TooV1SupervisionReadFields {...supervision.customControlData} />
            </CustomControlCollapseBody>

            {!props.itemState.initialIsOpen && (
                <ProcessItemFooter
                    isItemOpen={props.itemState.isOpen}
                    labelLess={translateKey('supervision.hideSupervision')}
                    labelMore={translateKey('supervision.showSupervision')}
                    onToggle={async (isOpened) => await props.updateItemState({ ...props.itemState, isOpen: isOpened })}
                />
            )}
        </>
    );
}
